import {ButtonHTMLAttributes, FC} from 'react';
import s from '../index.module.scss';

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'Primary' | 'Secondary' | 'Tertiary' | 'Success' | 'Danger';
    label: string;
    icon?: string;
}

export const TextButton: FC<IProps> = ({variant = 'Primary', label, icon, ...rest}) => {
    const buttonVariants = () =>
        `${variant === 'Primary' && s.primary} ${variant === 'Secondary' && s.secondary} ${
            variant === 'Tertiary' && s.tertiary
        } ${variant === 'Success' && s.success} ${variant === 'Danger' && s.danger}`;
    return (
        <button className={`${s.text} ${buttonVariants()}`} {...rest}>
            {icon && (
                <img 
                    src={icon} 
                    alt="" 
                    style={{ 
                        width: '16px', 
                        height: '16px', 
                        marginRight: '6px',
                        display: 'inline-block',
                        verticalAlign: 'middle'
                    }} 
                />
            )}
            {label}
        </button>
    );
};
